import React from 'react';
import Head from 'next/head';
import PartnerLogos from '@/components/overseaHome/ui/PartnerLogos';
import IPWorkflow from '@/components/overseaHome/ui/IPWorkflow';
import CapabilitiesOverview from '@/components/overseaHome/ui/CapabilitiesOverview';
import MainScreen from '@/components/overseaHome/ui/MainScreen';
import {
  MOBILE_BG_IMAGE,
  PC_BG_IMAGE,
} from '@/components/overseaHome/ui/MainScreen/media';
import Pricing from '@/components/overseaHome/ui/Pricing';
import FeedbackOverview from '@/components/overseaHome/ui/FeedbackOverview';
import CaseList from '@/components/overseaHome/ui/CaseList';
import TopAlert from '@/components/overseaHome/ui/TopAlert';
import Header from '@/components/overseaHome/layout/header';
import StartCreationBanner from '@/components/overseaHome/ui/StartCreationBanner';
import { Footer } from '@/components/overseaHome/layout';
import type { OfficialHomePageProps } from './types';
import { OfficialHomeContext } from './OfficialHomeContext';
import style from './OfficialHomeContent.module.scss';

/** 国内和海外官网共用展示主体；入口保留独立页面配置以支持后续定制。 */
export default function OfficialHomeContent(props: OfficialHomePageProps) {
  const {
    menus, activityList, countryCode,
  } = props;
  // 首页 Capabilities Overview 区域使用产品分组的二级分类作为标签、工具条目作为卡片。
  // 接口暂无顶级分类标识，此处通过已知中英文名称识别产品，避免混入文章等内容。
  // 该筛选仅作用于能力概览；顶部导航始终渲染完整 menus。
  const productMenus = menus.find((group) => group.category === 'Product' || group.category === '产品')?.list ?? [];

  return (
    <OfficialHomeContext.Provider value={props}>
      <div className={style.container}>
        <Head>
          <link
            rel="preload"
            as="image"
            type="image/png"
            href={PC_BG_IMAGE}
            media="(min-width: 768px)"
          />
          <link
            rel="preload"
            as="image"
            type="image/png"
            href={MOBILE_BG_IMAGE}
            media="(max-width: 767px)"
          />
        </Head>
        <Header showAlert={activityList.length > 0} menus={menus} />
        {/* 主内容地标只包含官网正文，使导航和页脚保持为同级页面地标。 */}
        <main>
          {/* 官网顶部活动横幅 */}
          {activityList.length > 0 && <TopAlert activityList={activityList} />}
          {/* 首屏 */}
          <MainScreen />
          {/* 合作伙伴 */}
          <PartnerLogos />
          {/* 案例列表 */}
          <CaseList />
          {/* 角色 IP 创作流程：滚动视频与步骤说明联动。 */}
          <IPWorkflow />
          {/* 能力概览 */}
          {productMenus.length > 0 && <CapabilitiesOverview productMenus={productMenus} />}
          {/* 价格 */}
          <Pricing />
          {/* 反馈概览 */}
          <FeedbackOverview />
          {/* 开始创作横幅 */}
          <StartCreationBanner />
        </main>
        {/* 页尾 */}
        <Footer countryCode={countryCode} />
      </div>
    </OfficialHomeContext.Provider>
  );
}
